import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { Layout } from 'antd';
import 'antd/dist/antd.css';
import './App.css'

import Login from './containers/Login'
import Signup from './containers/Signup';
import Home from './containers/Home';
import PostRequestChoose from './components/PostRequestChoose';
import PostTrip from './components/PostTrip';
import PostRequest from './components/PostRequest';
import FindRide from './components/FindRide';
import TripDetail from './components/TripDetail';
import TripDetailForDriver from './components/TripDetailForDriver';
import BookTrip from './components/BookTrip';
import UserProfile from './components/UserProfile';
import PrivateRoute from './components/PrivateRoute';
import Account from './components/Account';
import BookedSuccessfully from './components/BookedSuccessfully';
import MyTripsMenu from './components/MyTripsMenu';
import TripsPosted from './components/TripsPosted';
import RequestsPosted from './components/RequestsPosted';
import TripsBooked from './components/TripsBooked';
import TripRequests from './components/TripRequests';
import AppHeader from './components/AppHeader';
import HowItWorks from './components/HowItWorks';
import Help from './components/Help';
import Dashboard from './components/Dashboard';

class App extends Component {
  render() {
    const { Content, Footer } = Layout;
    return (
      
      <Router>
        <Layout className="layout">
            <Content style={{ padding: '0 00px' }}>
            <AppHeader />
              <Switch>
                  <Route path="/" exact component={Home} />
                  <Route path="/login" exact component={Login} />
                  <Route path="/signup" exact component={Signup} />
                  <Route path="/post-request-choose" exact component={PostRequestChoose} />
                  <PrivateRoute path="/post-trip" exact component={PostTrip} />
                  <PrivateRoute path="/post-request" exact component={PostRequest} />
                  <Route path="/find-ride" exact component={FindRide} />
                  <Route path="/trip-detail/:tripId" exact component={TripDetail} />
                  <Route path="/trip-detail-for-driver/:tripId" exact component={TripDetailForDriver} />
                  <PrivateRoute path="/trip-detail/book/:tripId" exact  component={BookTrip} />
                  <Route path="/user-profile/:userId" exact component={UserProfile} />
                  <PrivateRoute path="/account" component={Account} />
                  <PrivateRoute path="/booked-success" exact component={BookedSuccessfully} />
                  <PrivateRoute path="/mytrips" exact component={MyTripsMenu} />
                  <PrivateRoute path="/trips-posted" exact component={TripsPosted} />
                  <PrivateRoute path="/trips-booked" exact component={TripsBooked} />
                  <PrivateRoute path="/requests-posted" exact component={RequestsPosted} />
                  <PrivateRoute path="/trip-requests/:tripId" exact component={TripRequests} />
                  <Route path="/how-it-works" exact component={HowItWorks} />
                  <Route path="/help" exact component={Help} />
                  <PrivateRoute path="/dashboard" exact component={Dashboard} />
              </Switch>
            </Content>
            <Footer style={{ textAlign: 'center' }}>
              Villaride ©2019
            </Footer>
        </Layout>
      </Router>
    );
  }
}

export default App;

